import React, { useState, useEffect } from "react";
import { Button, Form, Input } from "antd/lib";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  CustLife_detail,
  addlifenum,
  PostQuoteLife,
  SelectedPayMethod,
} from "../../Redux/actions/NumLife";
import axios from "axios";
import moment from "moment";
export default function LifeSep3({ setCurrent, current }) {
  console.log(current);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const CusDeatail = useSelector((state) => state?.lifedetail?.cusInfo);
  const [loading, setLoading] = useState(false);
  const [BaseUrl, setBaseURL] = useState("");

  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
  }, [BaseUrl]);

  const OnFinish = (values) => {
    setLoading(true);
    console.log(values);
    const UpdateCus = {
      ...CusDeatail,
      Name: values?.name,
      Mobile: values?.phonenumber,
      Email: values?.email,
    };
    // moment(new Date).format(''),
    const postData1 = {
      PolicyTerm: "15",
      PremiumTerm: "15",
      SumProposed: "0",
      // PolicyTerm: CusDeatail?.PolicyTerm,
      // PremiumTerm:
      //   CusDeatail?.PolicyTerm === "10"
      //     ? "6"
      //     : CusDeatail?.PolicyTerm === "12"
      //     ? "6"
      //     : "8",
      Age: CusDeatail?.Age,
      BenefitOption: 2500,
      Gender: CusDeatail?.gender,
      IsSmoker: CusDeatail?.IsSmoker,
      IsGroupEmployee: "N",
      // PlanNo: "127",
      // SumProposed: "400000",
      PremiumProposed: 40000,
      TranDate: moment(new Date()).format("YYYY-MM-DD"),
      PremiumPaymentFrequency: 1005,
      // BenefitPayout: 1306,
      // BenefitFrequency: 1005,
      UserID: "REKAGJGEGH",
      // Riders: [],
    };

    const url = `${BaseUrl}v1/life_insurances/register`;
    axios
      .post(url, {
        phonenumber: values?.phonenumber,
      })
      .then((res) => {
        console.log(res);
        const NumData = res?.data;
        console.log("NumData", NumData);
        dispatch(addlifenum(NumData));
        dispatch(CustLife_detail(UpdateCus));
        dispatch(PostQuoteLife(postData1));
        dispatch(SelectedPayMethod("Yearly"));
        setLoading(false);
        history.push("/lifeLayout");
      })
      .catch((err) => {
        setLoading(false);
        console.log(err?.response?.data);
      });
  };

  return (
    <>
      <div className="step-container-health d-flex justify-content-center">
        <Form
          layout="vertical"
          form={form}
          style={{ width: "95%" }}
          requiredMark={true}
          onFinish={OnFinish}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                pattern: /^[A-Za-z\s]+$/,
                message: "Invalid Name, only letters are allowed",
              },
              {
                required: true,
                message: "please input name",
              },
            ]}
            initialValue={CusDeatail?.Name}
          >
            <Input placeholder="Enter Name (eg. Harry)" />
          </Form.Item>
          <Form.Item
            label="Mobile Number"
            name="phonenumber"
            rules={[
              {
                pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                message: "Invalid Mobile No",
              },
              { required: true, message: "Enter Mobile No" },
            ]}
            initialValue={CusDeatail?.Mobile}
          >
            <Input maxLength={10} placeholder="Mobile NUmber" />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                type: "email",
                message: "Please Input Email",
              },
            ]}
            initialValue={CusDeatail?.Email}
          >
            <Input
              autoComplete="off"
              style={{ width: "100%" }}
              placeholder="Email"
            />
          </Form.Item>
          <Form.Item>
            <div className="step-btn-health">
              {current && current > 1 ? (
                <Button
                  style={{ width: "40%" }}
                  onClick={() => setCurrent(current - 1)}
                >
                  Back
                </Button>
              ) : null}
              <Button
                loading={loading}
                type="primary"
                htmlType="submit"
                style={{ width: "40%" }}
              >
                View Quotes
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </>
  );
}
